var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{disabled: _vm.isDisabled}},[(_vm.isMobile)?_c('RotationMobile',_vm._g(_vm._b({},'RotationMobile',_vm.rotationProps,false),_vm.rotationEmits)):_c('RotationDesktop',_vm._g(_vm._b({},'RotationDesktop',_vm.rotationProps,false),_vm.rotationEmits))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }